/* ============
 * Supplier Module State
 * ============
 */

export default {
  all: [],
  items: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 5,
    totalCount: 0,
  },
  currentWarehouse: [],
  // products: [],
  products: {
    items: [],
    pagination: {
      currentPage: 1,
      lastPage: 0,
      limit: 5,
      totalCount: 0,
    },
  },
  transactions: [],
  transactionsV2All: [],
  transactionsV2: {
    items: [],
    pagination: {
      currentPage: 1,
      lastPage: 0,
      limit: 5,
      totalCount: 0,
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/warehouse/state.js